<template>
    <BaseTooltip
        location="top"
        :open-on-click="false"
        :text="tooltipText">
        <IconCopy
            v-if="!isCopied"
            @click="onClickCopy()" />
        <IconCheck
            v-else
            class="gst-icon-check" />
    </BaseTooltip>
</template>

<script>
import BaseTooltip from '@components/BaseTooltip.vue';
import { IconCopy, IconCheck } from '@assets';

export default {
    name: 'CopyToClipboard',
    components: {
        IconCopy,
        IconCheck,
        BaseTooltip,
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'components.copyToClipboard',
    },
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isCopied: false,
            tooltipText: this.$t('tooltipText'),
        };
    },
    methods: {
        async onClickCopy() {
            try {
                const type = 'text/plain';
                const blob = new Blob([this.value], { type });
                const data = [new ClipboardItem({ [type]: blob })];
                await navigator.clipboard.write(data);
                this.isCopied = true;
                this.tooltipText = this.$t('successfullyCopied');
            } catch (e) {
                alert(this.$t('unableToCopy'));
            } finally {
                setTimeout(() => {
                    this.tooltipText = this.$t('tooltipText');
                    this.isCopied = false;
                }, 2500);
            }
        },
    },
};
</script>

<style lang="scss">
@keyframes fadeIn {
    0% {
        opacity: 0.2;
    }
    25% {
        opacity: 0.7;
    }
    100% {
        opacity: 1;
    }
}
.gst-icon-check {
    height: 16px;
    animation-name: fadeIn;
    animation-duration: 1s;
    animation-timing-function: linear;
}
</style>
